import React, { useState } from "react";
import { Resultset, ResponseDetail } from "components/response";
import styles from "./SearchTab.module.css";
import { useSearch } from "hooks";
import { TabPane } from "reactstrap";

const SearchTab = ({ tabId, className }) => {
  const [detail, setDetail] = useState(null);
  const {
    status,
    result,
    actions: { execute },
  } = useSearch();
  const classNames = [styles.searchTab, className];
  classNames.push(detail != null ? styles.hasDetails : styles.default);
  return (
    <TabPane
      tabId={tabId}
      className={classNames.filter((_) => _ != null).join(" ")}
    >
      <div className={styles.report}>
        <div className={styles.summary}>
          <div className={styles.summaryWrapper}>
            {false && <p>{result.summary}</p>}
          </div>
        </div>
        <Resultset
          className={styles.list}
          setDetail={setDetail}
          status={status}
          result={result}
          execute={execute}
          detailId={detail != null ? detail.id : -1}
        />
      </div>
      {detail != null && (
        <ResponseDetail
          className={styles.detail}
          response={detail}
          handleClose={() => setDetail(null)}
        />
      )}
    </TabPane>
  );
};

export { SearchTab };
